var _g, _rect, _path, _path2, _g2, _rect2, _g3, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9821_9030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 16,
    height: 15,
    rx: 3,
    fill: "#64809B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 0.25,
    width: 15.5,
    height: 14.5,
    rx: 2.75,
    stroke: "#687E92",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32875 9.5133C6.33793 9.51537 5.60429 8.80242 5.60567 7.99983C5.60705 7.19587 6.3462 6.47878 7.33737 6.47706L9.01184 6.47395C9.10885 6.47377 9.20182 6.43506 9.27029 6.36633C9.33876 6.2976 9.37712 6.20449 9.37693 6.10748C9.37675 6.01047 9.33804 5.9175 9.26931 5.84903C9.20058 5.78056 9.10747 5.7422 9.01046 5.74239L7.33599 5.74549C6.01593 5.74859 4.87721 6.72183 4.8741 7.99845C4.87169 9.27646 6.00903 10.2469 7.33013 10.2449L10.6791 10.238C11.9998 10.2356 13.1385 9.26232 13.1406 7.98535C13.1424 7.93628 13.1344 7.88735 13.1169 7.84147C13.0994 7.79559 13.0728 7.7537 13.0388 7.71831C13.0047 7.68292 12.9639 7.65474 12.9187 7.63547C12.8736 7.61619 12.825 7.60621 12.7759 7.60612C12.7268 7.60602 12.6782 7.61582 12.6329 7.63493C12.5877 7.65403 12.5468 7.68205 12.5126 7.71732C12.4784 7.75258 12.4517 7.79437 12.434 7.84018C12.4164 7.88599 12.4081 7.9349 12.4097 7.98397C12.408 8.7876 11.6692 9.50503 10.678 9.50675L7.32875 9.5133Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.68319 8.01303C9.68306 8.11008 9.72148 8.20322 9.79002 8.27195C9.85855 8.34068 9.95158 8.37936 10.0486 8.3795C10.1457 8.37964 10.2388 8.34121 10.3076 8.27268C10.3763 8.20415 10.415 8.11112 10.4151 8.01406C10.4165 7.21009 11.1553 6.49335 12.1468 6.49128L15.4961 6.48542C16.4869 6.48335 17.2205 7.1963 17.2192 7.99889C17.2174 8.80251 16.4786 9.51995 15.4875 9.52167L13.813 9.52477C13.7645 9.524 13.7162 9.5329 13.6712 9.55096C13.6261 9.56902 13.5851 9.59588 13.5505 9.62996C13.5159 9.66404 13.4885 9.70467 13.4698 9.74947C13.4511 9.79428 13.4414 9.84236 13.4415 9.89091C13.4416 9.93946 13.4513 9.98752 13.4702 10.0323C13.489 10.077 13.5166 10.1176 13.5512 10.1515C13.5859 10.1855 13.627 10.2123 13.6721 10.2302C13.7173 10.2481 13.7655 10.2569 13.814 10.256L15.4885 10.2529C16.8089 10.2501 17.9476 9.27689 17.9504 7.99924C17.9531 6.72089 16.8155 5.75075 15.4947 5.75317L12.1454 5.75972C10.8257 5.76247 9.68664 6.73606 9.68388 8.01234",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9821_9030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 16,
    height: 15,
    rx: 3,
    fill: "#64809B"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 0.25,
    width: 15.5,
    height: 14.5,
    rx: 2.75,
    stroke: "#687E92",
    strokeWidth: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9821_9030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32875 9.5133C6.33793 9.51537 5.60429 8.80242 5.60567 7.99983C5.60705 7.19587 6.3462 6.47878 7.33737 6.47706L9.01184 6.47395C9.10885 6.47377 9.20182 6.43506 9.27029 6.36633C9.33876 6.2976 9.37712 6.20449 9.37693 6.10748C9.37675 6.01047 9.33804 5.9175 9.26931 5.84903C9.20058 5.78056 9.10747 5.7422 9.01046 5.74239L7.33599 5.74549C6.01593 5.74859 4.87721 6.72183 4.8741 7.99845C4.87169 9.27646 6.00903 10.2469 7.33013 10.2449L10.6791 10.238C11.9998 10.2356 13.1385 9.26232 13.1406 7.98535C13.1424 7.93628 13.1344 7.88735 13.1169 7.84147C13.0994 7.79559 13.0728 7.7537 13.0388 7.71831C13.0047 7.68292 12.9639 7.65474 12.9187 7.63547C12.8736 7.61619 12.825 7.60621 12.7759 7.60612C12.7268 7.60602 12.6782 7.61582 12.6329 7.63493C12.5877 7.65403 12.5468 7.68205 12.5126 7.71732C12.4784 7.75258 12.4517 7.79437 12.434 7.84018C12.4164 7.88599 12.4081 7.9349 12.4097 7.98397C12.408 8.7876 11.6692 9.50503 10.678 9.50675L7.32875 9.5133Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3309 6.4867C16.3217 6.48463 17.0554 7.19758 17.054 8.00017C17.0526 8.80413 16.3135 9.52122 15.3223 9.52294L13.6478 9.52605C13.5508 9.52623 13.4579 9.56494 13.3894 9.63367C13.3209 9.7024 13.2826 9.79551 13.2827 9.89252C13.2829 9.98953 13.3216 10.0825 13.3904 10.151C13.4591 10.2194 13.5522 10.2578 13.6492 10.2576L15.3237 10.2545C16.6437 10.2514 17.7825 9.27817 17.7856 8.00155C17.788 6.72354 16.6506 5.75306 15.3295 5.75513L11.9806 5.76203C10.6598 5.76444 9.52112 6.73768 9.51906 8.01465C9.51723 8.06372 9.52531 8.11265 9.54281 8.15853C9.56031 8.20441 9.58687 8.2463 9.62091 8.28169C9.65495 8.31708 9.69577 8.34526 9.74093 8.36453C9.78609 8.38381 9.83468 8.39379 9.88378 8.39388C9.93288 8.39398 9.9815 8.38418 10.0267 8.36507C10.072 8.34597 10.1129 8.31795 10.1471 8.28268C10.1812 8.24742 10.208 8.20563 10.2256 8.15982C10.2433 8.11401 10.2516 8.0651 10.2499 8.01603C10.2517 7.2124 10.9905 6.49497 11.9816 6.49325L15.3309 6.4867Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9821_9030",
    x: 3,
    y: 0,
    width: 16,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0 0.894118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9821_9030"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9821_9030",
    x: 3,
    y: 0,
    width: 16,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0 0.894118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9821_9030"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9821_9030",
    x: 0.874023,
    y: 5.74219,
    width: 16.2666,
    height: 12.5039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9821_9030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9821_9030",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIcon);
export default __webpack_public_path__ + "static/media/inputIcon.e9877bab381400018016333919cfe070.svg";
export { ForwardRef as ReactComponent };